<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Owner Account Codes &nbsp;
          <add-button
            link="/procurement-management/owner-account-codes/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">Owner Account Codes</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportowner_account_codes.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="owner_account_codes_excel"
                    :fields="excel_fields"
                    worksheet="Owner Account Codes"
                    name="Owner Account Code.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Owner</th>
                    <th>Parent</th>
                    <th>Account Code</th>
                    <th>Account Name</th>
                    <th>Classification</th>
                    <th>Account Head</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="owner_account_codes.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(owner_account_code, at) in owner_account_codes"
                    :key="`owner_account_code${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ owner_account_code.owner.name }}</td>
                    <td>{{ owner_account_code.parent.name }}</td>
                    <td>{{ owner_account_code.account_code }}</td>
                    <td>{{ owner_account_code.account_name }}</td>
                    <td>{{ owner_account_code.classification.name }}</td>
                    <td>{{ owner_account_code.account_head.name }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/procurement-management/owner-account-codes/${owner_account_code.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(owner_account_code.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import moment from "moment";

export default {
  name: "owner_account_code",
  data() {
    return {
      owner_account_codes: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      owner_account_codes_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Owner: "owner",
        Parent: "parent",
        "Account Name": "account_name",
        "Account Code": "account_code",
        Classification: "classification",
        "Account Head": "account_head",
        Deacription: "deacription",
        Date: "date",
        "Is Dispaly in Vessel": "is_display_in_vessel",
      },
      Exportowner_account_codes: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let owner_account_codes = await axios.get(
        `/owner_account_codes?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.owner_account_codes = owner_account_codes.data.data;
      this.count = owner_account_codes.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let owner_account_codes = await axios.get(
        `/owner_account_codes?search=${this.searchData}`
      );
      this.owner_account_codes = owner_account_codes.data.data;
      this.count = owner_account_codes.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Owner Account Codes Data";
      this.owner_account_codes_excel = [];
      let Exportowner_account_codes = [];
      Exportowner_account_codes = await axios.get(`/owner_account_codes`);
      this.Exportowner_account_codes = Exportowner_account_codes.data.data;
      let sr_no = 1;
      this.Exportowner_account_codes.forEach((owner_account_code) => {
        this.owner_account_codes_excel.push({
          sr_no: sr_no,
          account_name: owner_account_code.account_name
            ? owner_account_code.account_name
            : "",
          account_code: owner_account_code.account_code
            ? owner_account_code.account_code
            : "",
          owner: owner_account_code.owner ? owner_account_code.owner.name : "",
          parent: owner_account_code.parent
            ? owner_account_code.parent.name
            : "",
          classification: owner_account_code.classification
            ? owner_account_code.classification.name
            : "",
          account_head: owner_account_code.account_head
            ? owner_account_code.account_head.name
            : "",
          deacription: owner_account_code.description
            ? owner_account_code.description
            : "",
          date: owner_account_code.date
            ? moment(owner_account_code.date).format("DD-MM-YYYY")
            : "",

          is_display_in_vessel: owner_account_code.is_display_in_vessel
            ? "Yes"
            : "No",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=owner_account_codes`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
